<template>
  <va-modal
    :value="isOpen"
    id="callRatingDetailsModal"
    ref="callRatingDetailsModal"
    @cancel="onCancel"
    :hideDefaultActions="true"
  >
    <div slot="header" class="d-flex justify--space-between">
      <span
        class="modal-title">{{
          $t('clinical.call_rating_modal_title', {appointment_info: `${request.customer_number} (${moment(request.started_at).format('YYYY-MM-DD HH:mm')})`})
        }}</span>
    </div>
    <section class="evollu-form">
      <h5> {{ $t('clinical.appointment.title') }}</h5>
      <div class="form-row">
        <div class="col-12 col-md-6 mb-3"><span
          class="is-bold ">{{ $t('tables.columns.created_at') }}:</span>
          {{ moment(request.created_at).format('YYYY-MM-DD HH:mm') }}
        </div>
        <div class="col-12 col-md-6 mb-3"><span
          class="is-bold ">{{ $t('clinical.appointments.appointment_started_at') }}:</span>
          {{ moment(request.started_at).format('YYYY-MM-DD HH:mm') }}
        </div>
        <div class="col-12 col-md-6 mb-3"><span
          class="is-bold ">{{ $t('clinical.appointments.appointment_ended_at') }}:</span>
          {{ moment(request.ended_at).format('YYYY-MM-DD HH:mm') }}
        </div>
        <div class="col-12 col-md-6 mb-3"><span
          class="is-bold ">{{ $t('virtual_waiting_room.titles.customer_nr') }}:</span> {{ request.customer_number }}
        </div>
        <div class="col-12 col-md-6 mb-3"><span
          class="is-bold ">{{ $t('clinical.appointments.facility') }}:</span> {{ request.facility_name }}
        </div>
      </div>
      <h5>{{ $t('clinical.appointments.dispenser') }}</h5>
      <div class="row mb-1">
        <label class="is-bold">{{ $t('clinical.appointments.dispenser') }}:</label>&nbsp;
        <span>
          {{ request.dispenser_nickname || $t('clinical.appointments.undefined_user') }}
        </span>
      </div>

      <div class="row">
        <label class="is-bold ">{{ $t('clinical.call_ratings.dispenser_rating') }} </label>
        &nbsp;
        <va-rating v-if="request.dispenser_rating"
                   v-model="request.dispenser_rating"
                   :readonly="true"
                   size="medium"
                   color="info"
                   style="padding-top: 3px"/>
        <span v-else> N/A </span>
      </div>

      <div>
        <label class="is-bold ">{{ $t('clinical.call_ratings.dispenser_comment') }} </label>
        <va-input
          :value="request.dispenser_comment || $t('clinical.call_ratings.no_comment')"
          type="textarea"
          :min-rows="3"
          :readonly="true"
          :disabled="true"
        />
      </div>
      <hr>
      <h5>{{ $t('clinical.appointments.audiologist') }}</h5>
      <div class="row mb-1">
        <label class="is-bold ">{{ $t('clinical.appointments.audiologist') }}:</label>&nbsp;
        <span>
          {{ request.accepted_by_nickname || $t('clinical.appointments.undefined_user') }}
          </span>
      </div>

      <div class="row">
        <label class="is-bold ">{{ $t('clinical.call_ratings.audiologist_rating') }}</label>
        &nbsp;
        <va-rating v-if="request.audiologist_rating"
                   v-model="request.audiologist_rating"
                   :readonly="true"
                   size="medium"
                   color="info"
                   style="padding-top: 3px"/>
        <span v-else> N/A </span>
      </div>

      <div>
        <label class="is-bold ">{{ $t('clinical.call_ratings.audiologist_comment') }} </label>
        <va-input
          :value="request.audiologist_comment || $t('clinical.call_ratings.no_comment')"
          type="textarea"
          :min-rows="3"
          :readonly="true"
          :disabled="true"
        />
      </div>
    </section>
  </va-modal>
</template>

<script>
import _ from 'lodash'
export default {
  props: {
    request: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      isOpen: false
    }
  },
  mounted: function () {
    this.isOpen = true
  },

  methods: {
    onCancel: function () {
      this.$emit('modalClosed')
      setTimeout(() => {
        this.isOpen = false
      }, 500)
    }
  }
}
</script>
